export default __webpack_public_path__ + "static/media/forestly-noexpl-03_EN.9427ec20.png";